export default "__VITE_ASSET__BnyzO2nb__"